import { memo } from 'react';
import { IStatus, StatusPicker } from '@dfl/mui-react-common';
import useUpdateTestimonials from '../../hooks/useUpdateTestimonials';
import { COLLECTION_STATUS, COLLECTION_STATUS_MAP } from 'modules/cms/collections/constants/collection-status';
import { useTranslation } from 'react-i18next';

const TestimonyStatusPicker = ({ value, id, }: { value: any, id: string }) => {
  const { t } = useTranslation('common');
  const { mutate, isPending: isLoading } = useUpdateTestimonials(id);

  return (
    <StatusPicker
      name='enabled'
      options={COLLECTION_STATUS?.map((option) => ({
        ...option,
        title: t(option.title),
      }))}
      size={'small'}
      value={{
        ...(COLLECTION_STATUS_MAP?.get(value) as IStatus),
        title: t(COLLECTION_STATUS_MAP?.get(value)?.title as string),
      }}
      isLoading={isLoading}
      onChange={(status: any) => {
        mutate(status?._id);
      }}
    />
  );
};

export default memo(TestimonyStatusPicker);
